import React from "react";

export const dots = (
	<span className="loader">
		<span className="loader__item" />
		<span className="loader__item" />
		<span className="loader__item" />
	</span>
);
